import React from "react";
import styles from "./Articles.module.css";

export const ArticleHeader = ({children}) => {

    return <h1 className={styles.header}>{children}</h1>

}

export const ArticleH2 = ({children}) => {

    return <h2 className={styles.header2}>{children}</h2>

}

export const ArticleH3 = ({children}) => {

    return <h3 className={styles.header3}>{children}</h3>

}

export const ArticleH4 = ({children}) => {

    return <h4 className={styles.header4}>{children}</h4>

}

export const NumberedList = ({children}) => {

    return <ol className={styles.numberedList}>{children}</ol>

}

export const ArticleParagraph = ({children}) => {

    return <p className={styles.paragraph}>{children}</p>
}

export const ArticleText = ({children}) => {

    return <p className={styles.text}>{children}</p>
}

export const SectionHeader = ({children}) => {

    return <div className={styles.sectionHeader}>{children}</div>

}

export const SectionSubHeader = ({children}) => {
    return <h2 className={styles.sectionSubHeader}>{children}</h2>
}

export const SectionText = ({children}) => {

    return <p className={styles.sectionText}>{children}</p>

}

export const PinkText = ({children}) => {

    return <span className={styles.pinkText}>{children}</span>

}

export const BlueText = ({children}) => {
    return <span className={styles.blueText}>{children}</span>
}

export const LandingPageHeader = ({children}) => {
    return <h1 className={styles.landingPageHeader}>{children}</h1>
}

export const LandingPageSubHeader = ({children}) => {
    return <h2 className={styles.landingPageSubHeader}>{children}</h2>
}

export const FeatureCard = ({title, desc}) => {

    return (
        <div className={styles.featureCard}>
            <h3 className={styles.featureTitle}>{title}</h3>
            <p className={styles.featureDesc}>{desc}</p>
        </div>
    );


}